import React, { useRef, useEffect } from 'react';

const CalendlyBooking = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    if (!sectionRef.current) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    
    const elements = sectionRef.current.querySelectorAll('.reveal');
    elements.forEach(el => observer.observe(el));
    
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  // Load Calendly widget script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section
      id="booking"
      ref={sectionRef}
      className="py-24 bg-white relative overflow-hidden"
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-block px-3 py-1 mb-6 bg-blue-100 text-blue-600 rounded-full text-sm font-medium reveal opacity-0 transition-all duration-700 translate-y-8">
            Book a Meeting
          </div>
          <h2 className="heading-lg mb-6 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '100ms' }}>
            Schedule a Consultation
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '200ms' }}>
            Book a 30-minute session to discuss how Portco AI can transform your investment analytics workflow.
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-lg reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '300ms' }}>
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/contact-portcoai/30min" 
            style={{ minWidth: '320px', height: '700px' }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default CalendlyBooking;
